import React from 'react';
import LinkButton from '../link/linkButton';
import { connect } from 'redux-bundler-react';
import { FileTypes } from '@src/utils/enums';

import './fileDownloadList.scss';

const FileDownloadList = connect('doDownloadFile', ({ doDownloadFile, files }) => {
  const hideContainer = files?.filter((file) => file?.fileType !== null && file?.fileSize !== null)?.length === 0;

  const generateFileDisplay = (files) =>
    files?.map((file, index) => {
      if (file?.fileType !== null && file?.fileSize !== null) {
        return (
          <div key={file?.jpaDocumentID} id={file?.jpaDocumentID}>
            <p>{file?.displayMessage}</p>
            <ul>
              <li>
                <LinkButton
                  onClick={() =>
                    doDownloadFile(
                      `${file?.jpaDocumentID}_${file?.documentName}`,
                      FileTypes.Resource,
                      null,
                      'JPADocuments'
                    )
                  }
                  title={`${file?.documentDisplayName} [${file?.fileType?.toUpperCase()}, ${file?.fileSize}]`}
                  aria-label={`Download ${file?.documentDisplayName}`}
                >
                  {file?.documentDisplayName} [{file?.fileType?.toUpperCase()}, {file?.fileSize}]
                </LinkButton>
              </li>
            </ul>
          </div>
        );
      }
      return <React.Fragment key={file?.jpaDocumentID} />;
    });

  // Check if file exists in S3 by checking if fileSize and fileType values are available
  if (hideContainer) {
    return <></>;
  }

  return (
    <div className='file-download-container'>
      <div>{generateFileDisplay(files)}</div>
    </div>
  );
});

export default FileDownloadList;
